export default function Footer() {
  return (
    <footer className="app-footer">footer</footer>
  )
}